import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import FeedbackBanner from '../common/FeedbackBanner';

const Layout = () => {
  // Check localStorage for saved preference, default to expanded
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    const saved = localStorage.getItem('sidebarCollapsed');
    return saved ? JSON.parse(saved) : false;
  });
  
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  // Save preference to localStorage when it changes
  useEffect(() => {
    localStorage.setItem('sidebarCollapsed', JSON.stringify(sidebarCollapsed));
  }, [sidebarCollapsed]);

  const toggleSidebarCollapse = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const toggleMobileSidebar = () => {
    setMobileSidebarOpen(!mobileSidebarOpen);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Mobile sidebar backdrop */}
      <div 
        className={`fixed inset-0 bg-black/50 z-30 transition-opacity duration-300 lg:hidden
                  ${mobileSidebarOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} 
        onClick={toggleMobileSidebar}
      />
      
      {/* Sidebar - Desktop always visible, mobile controlled by state */}
      <div className={`lg:block ${mobileSidebarOpen ? 'block' : 'hidden'}`}>
        <Sidebar 
          isCollapsed={sidebarCollapsed} 
          toggleCollapse={toggleSidebarCollapse}
        />
      </div>
      
      {/* Main wrapper */}
      <div className={`transition-all duration-300 ease-in-out
                    ${sidebarCollapsed ? 'lg:ml-20' : 'lg:ml-64'}`}>
             
        {/* Navbar */}
        <Navbar 
          toggleSidebar={toggleMobileSidebar}
          isCollapsed={sidebarCollapsed}
        />
        
        {/* Main content area */}
        <main className="pt-16 min-h-screen">
          {/* 
            FIX: Removed the outer div with p-6/p-8 and merged padding 
            into this single container for a clean layout.
          */}
          <div className="max-w-7xl mx-auto p-6 lg:p-8">
            <Outlet />
          </div>
        </main>
        <FeedbackBanner /> 
      </div>
    </div>
  );
};

export default Layout;